// extracted by mini-css-extract-plugin
export default {"termsOfService":"TermsOfService_termsOfService__j98zY","spacer":"TermsOfService_spacer__9423H"};